import { FC, useRef } from "react";
import { useQuery } from "@tanstack/react-query";
import MetricsList from "@app/shared/metrics/MetricsList";
import MetricsBadge from "@app/shared/metrics/MetricsBadge";
import { QesColors } from "@app/shared/qes-standards/colors";
import NetworkSubmissionService from "@app/compliance-connect/network-submission/networkSubmissionService";
import { SpecialtyGroupExceptionStatusLabels } from "@app/exceptions/enums";

interface Props {
  submissionId: number;
}

export const NetworkProfileChartsSummary: FC<Props> = ({ submissionId }) => {
  const service = useRef(new NetworkSubmissionService()).current;

  const { data, isLoading } = useQuery({
    enabled: !!submissionId,
    queryFn: ({ signal }) => service.getNetworkProfileChartSummary(submissionId, signal),
    queryKey: ["ns-network-profile-chart-summary", submissionId],
    staleTime: 5 * 60 * 1000,
  });

  return (
    <>
    {!isLoading && 
      <>
        <MetricsList
          label="Total Gaps"
          items={[
            { color: QesColors.QesPrimaryGreen, label: "Fillable by a Single Provider", value: data?.fillableBySingleProviderCount ?? 0 },
            { color: QesColors.QesTertiaryYellow2, label: "Fillable by Multiple Providers", value: data?.fillableByMultipleProvidersCount ?? 0 },
            { color: QesColors.QesPrimaryRed, label: "Unfillable", value: data?.unfillableGapsCount ?? 0 },
          ]}
        />
        {data && (
          <MetricsBadge
            label="Regulator Review Status"
            testId="np-regulator-review-status-segment"
            text={SpecialtyGroupExceptionStatusLabels[data.regulatorReviewStatus]}
          />
        )}
      </>
    }
    </>
  );
};
